import CategoryList from '../components/category/List'
import CategoryCreate from '../components/category/Create'
import CategoryUpdate from '../components/category/Update'

export default [
  { name: 'CategoryList', path: '/categories/', component: CategoryList, props: { pageTitle: 'Category List' } },
  { name: 'CategoryCreate', path: '/categories/create', component: CategoryCreate, props: { pageTitle: 'Category Create' } },
  { name: 'CategoryUpdate', path: '/categories/edit/:id', component: CategoryUpdate, props: { pageTitle: 'Category Update' } }
]
